<template>
  <div>
    <b-card class="shadow">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <h5 class="mb-0 text-gray-800">
              {{ $t("Grupos do SCFV") }}
            </h5>

            <b-button-group>
              <b-button
                :class="viewFilterReport === true ? 'active' : ''"
                variant="outline-dark"
                @click="viewFilters"
              >
                <i class="fas fa-filter"></i>
                {{ $t("Filtros") }}
              </b-button>
              <b-button variant="outline-dark" @click="print()">
                <i class="fas fa-print"></i>
              </b-button>
              <b-button
                v-b-tooltip.hover
                :title="$t('Exportar')"
                variant="outline-dark"
                @click="exportar()"
              >
                <i class="fas fa-file-excel"></i>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <div v-if="viewFilterReport" class="col-12">
          <form ref="addItem" @submit.prevent="getAnalytics">
            <div class="row">
              <form-toggle
                v-model="filtrarDadosGrupo"
                grid="6"
                label="Filtrar por características do grupo"
              />

              <form-toggle
                v-model="filtrarDadosCadastro"
                grid="6"
                label="Filtrar por dados de cadastro e status"
              />

              <form-toggle
                v-model="filtrarDadosBaseFisica"
                grid="12"
                label="Filtrar por base física, técnico de referência, orientador e facilitador social"
              />
            </div>
            <div class="row">
              <template v-if="filtrarDadosGrupo">
                <div class="col-md-12">
                  <h5>CARACTERÍSTICAS DO GRUPO</h5>
                </div>
                <form-select
                  v-if="faixasetarias"
                  v-model="filtroFaixasEtarias"
                  :itens="faixasetarias"
                  label="Faixa Etária"
                  multiple
                />

                <form-select
                  v-model="filtroFormaAcesso"
                  :itens="$root.arrays.scfv_acesso"
                  grid="6"
                  label="Acesso"
                />
                <form-select
                  v-model="filtroPeriodicidade"
                  :itens="$root.arrays.scfv_periodicidade"
                  grid="6"
                  label="Periodicidade"
                  multiple
                />

                <form-select
                  v-model="filtroCarater"
                  :itens="$root.arrays.scfv_carater"
                  grid="6"
                  label="Caráter"
                />

                <form-select
                  v-model="filtroFormaExecucao"
                  :itens="$root.arrays.scfv_execucao"
                  grid="6"
                  label="Forma de Execução"
                />

                <form-toggle
                  v-model="filtrarInscritos"
                  grid="12"
                  label="Filtrar por número de inscritos"
                />

                <div v-if="filtrarInscritos" class="col-md-12 mb-3">
                  <label><b>Número de Inscritos</b></label>
                  <vue-slider
                    v-model="filtroInscritos"
                    :max="max"
                    :min="min"
                    :tooltip="'always'"
                    :tooltip-placement="'bottom'"
                  ></vue-slider>
                </div>

                <form-toggle
                  v-model="filtroImportadoSisc"
                  grid="12"
                  label="Importados do SISC?"
                />
              </template>
              <template v-if="filtrarDadosBaseFisica">
                <div class="col-md-12">
                  <h5>BASE FÍSICA, TÉCNICO, ORIENTADOR E FACILITADOR</h5>
                </div>
                <form-select
                  v-model="filtroUnidadesBase"
                  :disabled="loadingSearchUnidade"
                  :itens="unidades"
                  :loading="loadingSearchUnidade"
                  :multiple="true"
                  grid="6"
                  label="Base Física das Atividades"
                />

                <form-select
                  v-model="filtroTecnicosReferencia"
                  :disabled="loadingSearchTecnicosBase"
                  :itens="listtecnicosall"
                  :loading="loadingSearchTecnicosBase"
                  :multiple="true"
                  grid="6"
                  label="TÉCNICO DE REFERÊNCIA"
                />

                <form-select
                  v-model="filtroOrientadorSocial"
                  :disabled="loadingSearchTecnicosBase"
                  :itens="listtecnicosall"
                  :loading="loadingSearchTecnicosBase"
                  :multiple="true"
                  grid="6"
                  label="Orientador Social"
                />

                <form-select
                  v-model="filtroFacilitadorSocial"
                  :disabled="loadingSearchTecnicosBase"
                  :itens="listtecnicosall"
                  :loading="loadingSearchTecnicosBase"
                  :multiple="true"
                  grid="6"
                  label="Facilitador Social"
                />
              </template>

              <template v-if="filtrarDadosCadastro">
                <div class="col-md-12">
                  <h5>DADOS DE CADASTRO E STATUS</h5>
                </div>
                <form-select
                  v-model="filtroUnidades"
                  :disabled="loadingSearchUnidade"
                  :itens="unidades"
                  :loading="loadingSearchUnidade"
                  :multiple="true"
                  grid="6"
                  label="Filtrar por Unidade do Cadastro"
                  @input="getTecnicos()"
                />

                <form-select
                  v-model="filtroTecnicos"
                  :disabled="loadingSearchTecnicos"
                  :itens="listtecnicos"
                  :loading="loadingSearchTecnicos"
                  :multiple="true"
                  grid="6"
                  label="Filtrar por Técnico do Cadastro"
                  placeholder="Selecione uma unidade antes"
                />

                <form-calendar
                  v-model="data_inicio"
                  :max-date="dataNow"
                  grid="3"
                  label="Data inicial"
                />

                <form-calendar
                  v-model="data_fim"
                  :max-date="dataNow"
                  :min-date="data_inicio"
                  :required="verificaDataInicial"
                  grid="3"
                  label="Data final"
                />

                <form-select
                  v-model="filtroStatus"
                  :disabled="loadingStatus"
                  :itens="status"
                  :loading="loadingStatus"
                  grid="6"
                  label="Status"
                  multiple
                />
              </template>
            </div>

            <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right">
                <button
                  class="btn btn-default"
                  @click.prevent="limparFiltros(), (viewFilterReport = false)"
                >
                  <i class="fas fa-times"></i>
                </button>

                <button
                  class="btn btn-secondary"
                  type="button"
                  @click.prevent="limparFiltros()"
                >
                  {{ $t("Limpar Filtros") }}
                </button>
                <button
                  class="btn btn-success btn-submit"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="fas fa-chart-bar"></i>
                  {{ $t("Gerar Relatório") }}
                </button>
              </div>
            </div>
          </form>
        </div>

        <loading-report
          :loading="isLoadingMsg"
          icone="fa-smile-wink"
          mensagem="Por favor aguarde estamos realizando sua solicitação..."
        ></loading-report>

        <div class="col-md-12">
          <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
          />

          <print-content>
            <template v-slot:datas>
              <p class="d-flex align-items-center justify-content-between mb-4">
                <span>
                  Período selecionado:<b>{{ datas.start }} - {{ datas.end }}</b>
                  <b-link
                    v-b-popover.hover.top="
                      'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                    "
                    ariant="info"
                    class="mb-2"
                    href="#"
                    @click.prevent="void 0"
                  >
                    <i class="fas fa-info-circle"></i>
                  </b-link>
                </span>

                <span v-if="pagination.total"
                  >Total de Registros <b>{{ pagination.total }}</b
                  >, total por página <b>{{ pagination.perPage }}</b></span
                >
              </p>
            </template>

            <b-table
              :fields="[
                {
                  key: 'nome_grupo',
                  label: $t('Detalhes'),
                },
                {
                  key: 'cadastrado',
                  label: $t('Criado em'),
                },
                {
                  key: 'status',
                  label: $t('Status'),
                },
              ]"
              :items="itemList"
              :responsive="true"
              hover
              outlined
              show-empty
              small
              stacked="xs"
              striped
              table-class="mb-3"
            >
              <template v-slot:cell(nome_grupo)="data">
                <span class="d-block">
                  Nome:
                  <strong> {{ data.value }} </strong>
                </span>
                <span class="d-block">
                  Faixa Etária:
                  <strong>
                    {{ data.item.faixa_etaria_nome }}
                  </strong>
                </span>
                <span class="d-block">
                  Inscritos:
                  <strong
                    >{{ data.item.inscritos.length }}/{{
                      data.item.numero_vagas
                    }}
                  </strong>
                  <b-link
                    v-if="data.item.inscritos.length >= data.item.numero_vagas"
                    v-b-tooltip.hover
                    href="#"
                    title="Atingiu limite de inscritos!"
                  >
                    <b-icon
                      animation="fade"
                      icon="exclamation-triangle-fill"
                      variant="warning"
                    ></b-icon>
                  </b-link>
                </span>
                <div class="d-block">
                  Protocolo:
                  <strong> {{ data.item.protocolo }} </strong>
                </div>

                <div v-if="data.item.acesso_nome">
                  Acesso:
                  <b>{{ data.item.acesso_nome }}</b>
                </div>
                <div v-if="data.item.periodicidade_nome">
                  Periodicidade:
                  <b>{{ data.item.periodicidade_nome }}</b>
                </div>
                <div v-if="data.item.dias_semana_nomes">
                  Dia(s) da Semana:
                  <b>{{ data.item.dias_semana_nomes }}</b>
                </div>
                <div v-if="data.item.horario">
                  Horário: <b>{{ data.item.horario }}</b>
                </div>
                <div v-if="data.item.carater_nome">
                  Caráter:
                  <b>{{ data.item.carater_nome }}</b>
                </div>
                <div v-if="data.item.forma_execucao_nome">
                  Forma de Execução:
                  <b>{{ data.item.forma_execucao_nome }}</b>
                </div>

                <div v-if="filtrarDadosBaseFisica" class="d-block">
                  <div v-if="data.item.unidade_base">
                    Base Física das Atividades:
                    <b v-if="data.item.unidade_base">{{
                      data.item.unidade_base.nome
                    }}</b>
                  </div>
                  <span class="d-block">
                    Técnico de Referência:
                    <strong>
                      {{ data.item.responsavel.nome }}
                    </strong>
                  </span>
                  <div v-if="data.item.orientador">
                    Orientador Social:
                    <b v-if="data.item.orientador">{{
                      data.item.orientador.name
                    }}</b>
                  </div>
                  <div v-if="data.item.facilitador">
                    Facilitador Social:
                    <b v-if="data.item.facilitador">{{
                      data.item.facilitador.name
                    }}</b>
                  </div>
                </div>

                <div
                  v-if="filtrarDadosCadastro"
                  class="d-block border small py-2 px-4 rounded mt-2"
                >
                  <div v-if="data.item.unidade_cadastro">
                    Unidade do cadastro:
                    <b>{{ data.item.unidade_cadastro.nome }}</b>
                  </div>
                  <div v-if="data.item.tecnico_cadastro">
                    Técnico do cadastro:
                    <b>{{ data.item.tecnico_cadastro.name }}</b>
                  </div>
                </div>
              </template>
              <template v-slot:cell(cadastrado)="data">
                <strong>{{ data.value }}</strong>
              </template>
              <template v-slot:cell(status)="data">
                <span v-html="data.item.status_nome"></span>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center my-5">
                  <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                  />
                  <h3 class="bold">
                    {{ $t("No records found") }}
                  </h3>
                </div>
              </template>
            </b-table>
          </print-content>

          <div class="row align-items-center no-print">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  v-model="perPage"
                  class="form-control"
                  style="width: 70px"
                  v-on:change="getAnalytics"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                {{ $t("of") }}
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>

          <div v-if="!loading" class="box-btn-print no-print">
            <b-button
              v-b-tooltip.hover
              :title="$t('Visualizar e Imprimir')"
              class="py-2 d-block"
              size="sm"
              type="button"
              variant="primary"
              @click="print()"
            >
              <i class="fas fa-print"></i>
            </b-button>

            <b-button
              v-b-tooltip.hover
              :title="$t('Exportar para Excel')"
              class="py-2 d-block"
              size="sm"
              style="padding: 6px 14px"
              type="button"
              variant="default"
              @click="exportar"
            >
              <i class="fas fa-file-download"></i>
            </b-button>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "SCFV",
  metaInfo() {
    return {
      title: this.$i18n.t("Grupos SCFV"),
    };
  },
  data() {
    return {
      novo_grupo: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      itemList: [],
      participantes: [],
      filtro: null,
      user_id: null,

      faixasetarias: [],
      tecnicos: {},
      isLoading: false,
      isLoadingMsg: false,

      loadingSearchUnidade: false,
      loadingSearchTecnicos: true,
      loadingSearchTecnicosBase: true,
      loadingStatus: false,

      datas: [],
      filtrarDatas: false,
      filtroDatas: [],

      status: [],
      unidades: [],
      tecnicos: [],
      tecnicos_base: [],

      filtroFaixasEtarias: [],
      filtroFormaAcesso: null,
      filtroPeriodicidade: [],
      filtroCarater: null,
      filtroFormaExecucao: null,
      filtroImportadoSisc: false,

      filtroUnidades: [],
      filtroTecnicos: [],
      filtroUnidadesBase: [],
      filtroTecnicosReferencia: [],
      filtroOrientadorSocial: [],
      filtroFacilitadorSocial: [],

      filtroInscritos: [0, 30],
      filtroStatus: [],

      filtrarDadosCadastro: false,
      filtrarDadosBaseFisica: false,
      filtrarDadosGrupo: true,
      filtrarInscritos: false,
    };
  },
  created() {
    this.min = 0;
    this.max = 30;
    this.enableCross = false;
  },
  mounted() {
    this.getStatus();
    this.getTecnicos();
    this.getTecnicosAll();
    this.getUnidades();
    this.getAnalytics();

    this.faixasetarias = this.$root.arrays.scfv_faixa_etaria;

    if (
      this.faixasetarias[this.faixasetarias.length - 1].value !=
      "Todas as Idades"
    ) {
      this.faixasetarias.push({
        id: this.faixasetarias[this.faixasetarias.length - 1].id + 1,
        value: "Todas as Idades",
      });
    }
  },
  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      return map;
    },
    listtecnicosall() {
      const pessoas = this.tecnicos_base;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      return map;
    },
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      this.isLoadingMsg = true;
      this.loading = true;

      //   Gerar excel
      //   this.item.relatorio = "ok";
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/report/get/scfv/grupos", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroFaixasEtarias: this.filtroFaixasEtarias,
            filtroFormaAcesso: this.filtroFormaAcesso,
            filtroPeriodicidade: this.filtroPeriodicidade,
            filtroCarater: this.filtroCarater,
            filtroFormaExecucao: this.filtroFormaExecucao,
            filtroInscritos: this.filtroInscritos,
            filtroImportadoSisc: this.filtroImportadoSisc,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroUnidadesBase: this.filtroUnidadesBase,
            filtroTecnicosReferencia: this.filtroTecnicosReferencia,
            filtroOrientadorSocial: this.filtroOrientadorSocial,
            filtroFacilitadorSocial: this.filtroFacilitadorSocial,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.itemList = response.data.data;
          this.datas = response.data.datas;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAnalytics();
          } else {
            this.loading = false;
            this.isLoadingMsg = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.isLoadingMsg = false;
        })
        .finally(() => {
          this.loading = false;
          this.isLoadingMsg = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.itemList["exportGrupos"] = "ok";

      swal.fire({
        title: "Aguarde",
        text: "O Arquivo está sendo gerado.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/report/get/scfv/grupos", {
          params: {
            page: this.page,
            search: this.search,
            exportGrupos: "ok",
            perPage: this.perPage,
            filtroFaixasEtarias: this.filtroFaixasEtarias,
            filtroFormaAcesso: this.filtroFormaAcesso,
            filtroPeriodicidade: this.filtroPeriodicidade,
            filtroCarater: this.filtroCarater,
            filtroFormaExecucao: this.filtroFormaExecucao,
            filtroInscritos: this.filtroInscritos,
            filtroImportadoSisc: this.filtroImportadoSisc,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroUnidadesBase: this.filtroUnidadesBase,
            filtroTecnicosReferencia: this.filtroTecnicosReferencia,
            filtroOrientadorSocial: this.filtroOrientadorSocial,
            filtroFacilitadorSocial: this.filtroFacilitadorSocial,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
          },
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => (this.isLoadingMsg = false));
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
        });
    },
    getTecnicos() {
      this.tecnicos = [];
      this.loadingSearchTecnicos = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => (this.loadingSearchTecnicos = false));
    },
    getTecnicosAll() {
      this.tecnicos = [];
      this.loadingSearchTecnicosBase = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`)
        .then((response) => {
          this.tecnicos_base = response.data;
        })
        .finally(() => (this.loadingSearchTecnicosBase = false));
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/report/status/scfv`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => (this.loadingStatus = false));
    },
    limparFiltros() {
      this.filtroFaixasEtarias = [];
      this.filtroFormaAcesso = null;
      this.filtroPeriodicidade = [];
      this.filtroCarater = null;
      this.filtroFormaExecucao = null;

      this.filtroUnidades = [];
      this.filtroTecnicos = [];

      this.filtrarDadosBaseFisica = false;
      this.filtroUnidadesBase = [];
      this.filtroTecnicosReferencia = [];
      this.filtroOrientadorSocial = [];
      this.filtroFacilitadorSocial = [];

      this.filtroImportadoSisc = [];

      this.filtroInscritos = [0, 30];
      this.filtrarInscritos = false;
      this.filtroStatus = [];

      this.data_inicio = "";
      this.data_fim = "";
      this.verificaDataInicial = false;
      this.getAnalytics();
    },
  },
};
</script>
